module.exports = __webpack_public_path__ + "img/shape-11.e5782f03.svg";